import { storeToRefs } from "pinia";
import { useAuthStore } from "@/stores/AuthStore";

export function useCurrentUser() {
  const authStore = useAuthStore();
  const { currentUser } = storeToRefs(authStore);

  return currentUser;
}
